import { Link } from 'react-router-dom'
import { getTvUrlFromGif, openTvFromGif } from 'shared/util/tv'
import css from './options.css'
import { useGifDetailPermissions } from 'shared/hooks/use-permissions'

const ViewOptions = ({ className, gif }) => {
    const permissions = useGifDetailPermissions(gif.id)
    const { path } = gif
    const onTvClick = e => {
        e.preventDefault()
        openTvFromGif(gif)
    }
    return (
        <div className={className}>
            {permissions && permissions.edit && <Link className={css.edit} to={`${path}/edit`} />}
            <Link className={css.tile} to={`${path}/tile`} />
            <Link className={css.fullscreen} to={`${path}/fullscreen`} />
            <a className={css.tv} href={getTvUrlFromGif(gif)} onClick={onTvClick} />
        </div>
    )
}

export default ViewOptions
